import { useFormContext } from '@american-autonomy/ag-ui';

import FormGrid from 'components/FormGrid';
import FarmNameField from 'components/fields/FarmNameField';
import SelectClientField from 'components/fields/SelectClientField';

import useTranslation from './hooks/useTranslation';

import { CLIENT_FIELD_NAME, FARM_NAME_FIELD_NAME, TEST_ID } from './constants';
import type { FarmFormSchema, FieldPath, Props } from './types';

const FarmFormFields = <T extends FarmFormSchema>({
    children,
    namePrefix,
    testId = TEST_ID
}: Props<T>) => {
    const { FARM_NAME_FIELD_PLACEHOLDER } = useTranslation();
    const { control } = useFormContext<T>();

    const fieldName = (name: keyof FarmFormSchema) =>
        (namePrefix ? `${namePrefix}.${name}` : String(name)) as FieldPath<T>;

    return (
        <FormGrid testId={testId}>
            <FarmNameField<T>
                control={control}
                isRequired={true}
                name={fieldName(FARM_NAME_FIELD_NAME)}
                placeholder={FARM_NAME_FIELD_PLACEHOLDER}
            />

            <SelectClientField<T>
                control={control}
                isRequired={true}
                name={fieldName(CLIENT_FIELD_NAME)}
            />

            {children}
        </FormGrid>
    );
};

export default FarmFormFields;
